import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../_services/fundraising/vendor.service';
import { Location } from '../../_models/fundraising/Location';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../_services/dialog.service';

@Component({
    selector: 'app-location-create',
    templateUrl: './location-create.component.html',
    styleUrls: ['./location-create.component.css']
})

export class LocationCreateComponent implements OnInit {

    public form: FormGroup;

    public locationId: number;
    public location: Location;

    public hasValidationErrors = false;

    constructor(
        private vendorService: VendorService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private fb: FormBuilder
    ) { }

    ngOnInit(): void {
        this.route.params
        .subscribe(params => {
          this.locationId = params['id'];
            this.vendorService.getVendorLocationById(this.locationId)
                .subscribe(l => {
                    this.location = l;

                    this.form = this.fb.group({});  
                }
            )
        });
    }


    save() {

        this.hasValidationErrors = !this.form.valid;
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        if (this.hasValidationErrors) {
          this.form.markAllAsTouched();
          this.form.markAsDirty();
          return;
        }

        const location = new Location(this.form.controls.location.value);

        if(this.locationId > 0) {
            this.vendorService.updateVendorLocation(location).subscribe(
              () => { 
                this.spinner.hide();
                this.navigateUp();
              },
              error => {
                this.spinner.hide();
                this.dialogService.alert("Unable to update location", error.error, this.viewRef);
              }
            );
          } else {
            this.vendorService.createVendorLocation(location).subscribe(
              () => { 
                this.spinner.hide();
                this.navigateUp();
              },
              error => {
                this.spinner.hide();
                this.dialogService.alert("Unable to create location", error.error, this.viewRef);
              }
            );
          }
    }

    public navigateUp() {
        this.router.navigate([this.locationId > 0 ? '../../' : '../'], {relativeTo: this.route});
      }


}